import Http from '@/http/bhiotrack';
import { serialize } from '@/utils';

const getAllPlans = (params) => Http.get(`/plan${serialize(params)}`);
const getPlan = (id) => Http.get(`/plan/${id}`);

export const plansService = {
  getAllPlans,
  getPlan,
};
